interface ImagePlaceholderProps {
  className?: string;
  label?: string;
  labelPosition?: 'center' | 'top' | 'bottom';
}

export default function ImagePlaceholder({
  className = '',
  label = 'Prostor za sliko',
  labelPosition = 'center',
}: ImagePlaceholderProps) {
  const justify =
    labelPosition === 'top'
      ? 'justify-start pt-16 md:pt-20'
      : labelPosition === 'bottom'
        ? 'justify-end pb-16 md:pb-20'
        : 'justify-center';

  return (
    <div
      className={`flex flex-col items-center gap-2 border-2 border-dashed border-foreground-50/15 bg-background-200/60 text-foreground-400 ${justify} ${className}`}
      aria-label={label}
    >
      <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-100/70">
        <i className="ri-image-line text-lg md:text-xl"></i>
      </div>
      <span className="text-[11px] md:text-xs font-medium tracking-widest uppercase">{label}</span>
    </div>
  );
}